import React from 'react';
import { Container, Box, Typography, AppBar, Toolbar, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/');
    };

    return (
        <Box>
            {/* Header */}
            <AppBar
                position="sticky"
                sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
                }}
            >
                <Toolbar>
                    <IconButton onClick={handleBack} sx={{ color: 'primary.main', mr: 2 }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <img
                            src="/logo-192x192.png"
                            alt="Find solution Logo"
                            style={{ height: '32px', width: '32px', marginRight: '12px' }}
                        />
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                color: 'primary.main'
                            }}
                        >
                            Find solution
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Content */}
            <Container maxWidth="md" sx={{ py: 6 }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 'bold',
                        color: 'grey.800',
                        mb: 4,
                        textAlign: 'center'
                    }}
                >
                    Polityka Prywatności
                </Typography>

                <Box sx={{ '& > *': { mb: 3 } }}>
                    <Typography variant="body1" sx={{ color: 'grey.600', mb: 4, textAlign: 'center' }}>
                        Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL')}
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        1. Informacje ogólne
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych użytkowników aplikacji Find solution. Administratorem danych osobowych jest [Nazwa firmy], z siedzibą w [Adres].
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        2. Jakie dane zbieramy
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Zbieramy następujące kategorie danych:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Odpowiedzi na pytania w ankiecie psychologicznej</li>
                        <li>Dane kontaktowe (adres e-mail) - jeśli je podasz</li>
                        <li>Dane techniczne (adres IP, typ przeglądarki, czas korzystania z aplikacji)</li>
                        <li>Informacje o interakcjach z aplikacją</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        3. Cel przetwarzania danych
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Twoje dane przetwarzamy w celu:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Generowania spersonalizowanego planu działania</li>
                        <li>Świadczenia usług psychologicznego wsparcia</li>
                        <li>Poprawy jakości naszych usług</li>
                        <li>Komunikacji z użytkownikami (jeśli wyrazili zgodę)</li>
                        <li>Zapewnienia bezpieczeństwa aplikacji</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        4. Podstawa prawna
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Przetwarzamy Twoje dane na podstawie:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Zgody (art. 6 ust. 1 lit. a RODO)</li>
                        <li>Wykonania umowy (art. 6 ust. 1 lit. b RODO)</li>
                        <li>Prawnie uzasadnionego interesu (art. 6 ust. 1 lit. f RODO)</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        5. Udostępnianie danych
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Twoje dane mogą być udostępniane:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Dostawcom usług technicznych (hosting, analityka)</li>
                        <li>Organom państwowym - jeśli wymaga tego prawo</li>
                        <li>Nie sprzedajemy Twoich danych osobowych stronom trzecim</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        6. Okres przechowywania danych
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Dane przechowujemy przez okres niezbędny do realizacji celów, dla których zostały zebrane, nie dłużej niż przez 3 lata od ostatniego korzystania z aplikacji, chyba że prawo wymaga dłuższego przechowywania.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        7. Twoje prawa
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Masz prawo do:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Dostępu do swoich danych</li>
                        <li>Sprostowania nieprawidłowych danych</li>
                        <li>Usunięcia danych</li>
                        <li>Ograniczenia przetwarzania</li>
                        <li>Przenoszenia danych</li>
                        <li>Wniesienia sprzeciwu wobec przetwarzania</li>
                        <li>Cofnięcia zgody w dowolnym momencie</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        8. Bezpieczeństwo danych
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony Twoich danych osobowych przed nieuprawnionym dostępem, utratą, zniszczeniem lub ujawnieniem.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        9. Pliki cookies
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Nasza aplikacja może używać plików cookies w celu poprawy funkcjonalności i analizy ruchu. Możesz zarządzać ustawieniami cookies w swojej przeglądarce.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        10. Kontakt
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        W sprawach dotyczących ochrony danych osobowych możesz skontaktować się z nami pod adresem: [email kontaktowy]
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        11. Zmiany w polityce prywatności
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. O wszelkich zmianach będziemy informować użytkowników poprzez aplikację.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default PrivacyPolicyPage;

